///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CustomerDTO } from '../../../generated/shared-types.model';
import { GtthCustomerService } from '../../../services/customer/customer.service';
import { Store } from '@ngrx/store';
import { deleteCustomer } from '../../store/customer-config.actions';
import { GtthLocalStorageService } from '../../../shared/auth/localStorage.service';
import { PreloaderService } from '../../../services/preloader.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'winde-customer-delete-dialog',
    templateUrl: './delete-customer-dialog.component.html',
    standalone: false
})
export class DeleteCustomerDialogComponent {
    public customer: CustomerDTO = this.data.payload;

    constructor(
        private readonly customerService: GtthCustomerService,
        private readonly preloaderService: PreloaderService,
        private readonly store: Store,
        private readonly localStorageService: GtthLocalStorageService,
        public readonly dialogRef: MatDialogRef<DeleteCustomerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { payload: CustomerDTO }
    ) {}

    @HostListener('document:keydown.enter', ['$event'])
    handleKeyboardUpEvent(event: KeyboardEvent) {
        event.preventDefault();
        this.confirmDelete(this.customer.id);
    }

    public confirmDelete(id: number): void {
        this.preloaderService.show();

        this.customerService
            .delete(id)
            .pipe(finalize(() => this.preloaderService.hide()))
            .subscribe(() => {
                this.dialogRef.close();
                this.localStorageService.clearSelectedCustomerId();
                this.store.dispatch(deleteCustomer({ id }));
            });
    }
}
